import styled from 'styled-components';
export const ModalCross = styled.div`
  color: black;
  background: white;
  outline: 0;
  border-radius: 10px;
  padding-bottom: 1.5em;
`;

export const ModalHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 2px solid ${(props) => props.theme.dividerColor};
  .heading {
    display: flex;
    h5 {
      margin: 0;
    }
    i {
      margin-top: 2px;
      margin-right: 10px;
    }
  }
  .modal_close i {
    font-size: 16px;
    cursor: pointer;
  }
`;
